import React, { Suspense, lazy } from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import "./index.css";

// Lazy loading components to handle potential errors
const HomePage = lazy(() => import("./pages/HomePage"));
const WalletDetail = lazy(() => import("./components/WalletDetail"));
const WalletAnalyzerPage = lazy(() => import("./pages/WalletAnalyzerPage"));
const TokenExplorer = lazy(() => import("./components/TokenExplorer"));
const TokenAnalyzerPage = lazy(() => import("./pages/TokenAnalyzerPage"));
const SoteriaTokenPage = lazy(() => import("./pages/SoteriaTokenPage"));
const LiquidityProviderPage = lazy(() => import("./pages/LiquidityProviderPage"));

// Error boundary component
class ErrorBoundary extends React.Component<
  { children: React.ReactNode },
  { hasError: boolean }
> {
  constructor(props: { children: React.ReactNode }) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return <div>Something went wrong. Please refresh the page.</div>;
    }

    return this.props.children;
  }
}

function App() {
  return (
    <Layout>
      <ErrorBoundary>
        <Suspense fallback={<div>Loading...</div>}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/wallet-analyzer" element={<WalletAnalyzerPage />} />
            <Route path="/token-analyzer" element={<TokenAnalyzerPage />} />
            <Route path="/soteria-token" element={<SoteriaTokenPage />} />
            <Route path="/liquidity-provider" element={<LiquidityProviderPage />} />
            <Route path="/wallet" element={<WalletDetail />} />
            <Route path="/tokens" element={<TokenExplorer />} />
            <Route
              path="/about"
              element={<div>Information about OpenGPU Network coming soon</div>}
            />
            <Route
              path="/charts"
              element={<div>Price Charts coming soon</div>}
            />
            <Route path="/settings" element={<div>Settings coming soon</div>} />
            <Route path="*" element={<div>Page not found</div>} />
          </Routes>
        </Suspense>
      </ErrorBoundary>
    </Layout>
  );
}

export default App;
